import React, { Component } from 'react';
import { Icon } from 'antd';
import classnames from 'classnames';
import { ImageUpload } from '@comall-backend-builder/components-basis';
import { utils } from '../../../services/utils';
import './index.less';
/**
 * 单选图片
 */
export class UploadPicture extends Component<{
    value?: any;
    className?: string;
    uploadAction: string;
    sourceRoot: { image?: string };
    onChange?: (value: any) => void;
}> {
    state = {
        uploadLoading: false,
    };
    render() {
        const { value, uploadAction, sourceRoot, className, onChange } = this.props;
        const uploadButton = (
            <div>
                <Icon type={this.state.uploadLoading ? 'loading' : 'plus'} />
                <div className="ant-upload-text">上传</div>
            </div>
        );

        const uploadProps = {
            value: value,
            name: 'fileName',
            fileName: 'fileName',
            className: classnames('item-uploader', className),
            showUploadList: false,
            uploadType: 'single',
            mode: 'picture-card',
            accept: 'image/*',
            uploadUrl: uploadAction,
            preview: {
                type: 'popover',
                src: value,
            },
            uploadCompleteMessage: null,
            onChange: (v: any) => {
                if (v && v.length > 0) {
                    onChange(v[0].path);
                } else {
                    onChange(v);
                }
                return {};
            },
        };
        return (
            <div className="picture-box">
                <ImageUpload {...uploadProps} listType={'picture-card'}>
                    {value ? (
                        <img
                            className="item-img"
                            src={utils.formatImageUrl(sourceRoot, value)}
                            alt="item-pic"
                        />
                    ) : (
                        uploadButton
                    )}
                </ImageUpload>
            </div>
        );
    }
}
